module.exports = __webpack_public_path__ + "static/media/malaysia.fccfc766.svg";